import React, { useEffect, useState } from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CardContent,
  Card,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { setMaterialSellDialog } from '../redux';
import { getCheckedMaterialsForSell } from '../../helperFunctions';

export default props => {
  const { hasButtons, task } = props;
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();

  const { sellMaterials, ticketRouterMessages } = useSelector(state => state.tasks.data);
  const materialSellDialog = useSelector(state => state.tasks.materialSellDialog);

  const fontSize = width <= 500 ? '4vw' : '20px';

  const [checkedMaterials, setCheckedMaterials] = useState([]);

  useEffect(() => {
    if (materialSellDialog.open) return;
    getCheckedMaterialsForSell(task.id, dispatch).then(res => setCheckedMaterials(res));
  }, [materialSellDialog.open, task.id, dispatch]);

  useEffect(() => {
    getCheckedMaterialsForSell(task.id, dispatch).then(res => setCheckedMaterials(res));
  }, [task.id, dispatch]);

  return (
    <Card style={{ marginTop: '3px' }}>
      <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
        <Typography
          gutterBottom
          component="span"
          style={{
            fontSize,
            color: 'white',
            padding: '1px',
            marginRight: '4px',
            display: 'flex',
          }}
        >
          Устройства за Продажба
          {hasButtons && (
            <Chip
              style={{ margin: '1px', fontSize }}
              onClick={() => dispatch(setMaterialSellDialog({ open: true, taskId: task.id }))}
              clickable
              label="Управлявай"
            />
          )}
          {ticketRouterMessages[task.ticketId] && <>{ticketRouterMessages[task.ticketId]}</>}
        </Typography>
      </div>
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize }} size="small">
                Име
              </TableCell>
              <TableCell style={{ fontSize }} size="small">
                Сер. номер
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sellMaterials
              ?.filter(x => checkedMaterials.includes(x.serialNumber))
              .map(x => (
                <TableRow key={x.serialNumber || x.materialId}>
                  <TableCell style={{ fontSize }} size="small">
                    {x.materialName}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.serialNumber}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
